module.exports = __webpack_public_path__ + "img/2.033af62d.png";